import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface ModalState {
  brandId: string;
  brandName: string;
}

const initialState: ModalState = {
  brandId: '',
  brandName: '',
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openRequestModal: (state, action: PayloadAction<{ brandId: string; brandName: string }>) => {
      return { ...state, brandId: action.payload.brandId, brandName: action.payload.brandName };
    },
    closeRequestModal: (state) => {
      return { ...state, brandId: '', brandName: '' };
    },
  },
});

export const { openRequestModal, closeRequestModal } = modalSlice.actions;
export default modalSlice.reducer;
